import React from "react";

const FundraiserExpired: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white shadow-2xl rounded-2xl p-10 text-center max-w-lg border-2 border-red-500">
        <h1 className="text-3xl font-bold text-red-600 mb-4">
          ⏰ Time Has Expired
        </h1>
        <p className="text-lg text-gray-800">
          The fundraiser is no longer accepting any orders.
        </p>
      </div>
    </div>
  );
};

export default FundraiserExpired;
